import { Color } from '../../Enum/Color';
import { PieChartTotals, PieChartTotalsDTOInterface } from '../../Interface/Hook/PieChart/PieChartTotalsDTOInterface';
import { Scopable } from '../../Interface/Scopable';
import { useContext } from 'react';
import { Result } from '../../Interface/Response/Validator/Result';
import ResultContext from '../../Context/ResultContext';

const reduceScopeToPieChartTotals = (acc: PieChartTotals, currValue: Scopable): PieChartTotals => {
    if (currValue.resultaat === Color.Green) {
        acc.match += 1;
    }
    if (currValue.resultaat !== Color.Blue) {
        acc.total += 1;
    }
    return acc;
};

const getPieChartTotals = (rules: Scopable[]): PieChartTotals => {
    return rules.reduce(reduceScopeToPieChartTotals, {
        match: 0,
        total: 0,
    });
};

const useGetPieChartTotals = (): PieChartTotalsDTOInterface | null => {
    const result = useContext<Result | null>(ResultContext);

    if (!result) {
        return null;
    }

    return {
        acceptanceFeatures: getPieChartTotals(result.beoordeling.beoordelingResponse.regel)
    };
};

export default useGetPieChartTotals;
